<template>
	<div class="grow relative">
		<div class="flex items-end gap-3">
			<LabeledObject full :required="required">
				<template #label>{{ label }}</template>
				<input v-model="term" type="text" @keyup.enter.stop="search" @keyup.stop="clear">
			</LabeledObject>
			<PrimaryButton :color="Color.Blue" @click.stop="search">
				<i class="fa-solid fa-search"/>
			</PrimaryButton>
		</div>
		<SearchResults v-if="results.length > 0 || searching">
			<SearchResultItem v-if="searching">
				<Searching/>
			</SearchResultItem>
			<SearchResultItem v-for="country in results" @click.stop="select(country)">
				<div class="grow flex items-center gap-2">
					<img :src="country.image_url" class="w-6" :alt="country.name">
					<p>{{ country.name }}</p>
				</div>
			</SearchResultItem>
		</SearchResults>
	</div>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {type Country} from '@/Types/Country'
import Searching from '@/Components/Searching.vue'
import LabeledObject from '@/Components/LabeledObject.vue'
import SearchResults from '@/Components/Search/SearchResults.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import SearchResultItem from '@/Components/Search/SearchResultItem.vue'
import {showInfo, showSuccess, showValidationErrors, showWarning} from '@/helpers'

defineProps<{
	label:string,
	required?:boolean,
}>()
const emit = defineEmits([
	'selected',
])
const term:Ref<string> = ref('')
const searching:Ref<boolean> = ref(false)
const results:Ref<Array<Country>> = ref([])

function search():void{
	if(!searching.value){
		if(term.value.length >= 3){
			searching.value = true
			showInfo(trans('general.searching'))
			axios.post(route('search.index', 'countries'), {
				term: term.value,
			}).then(({data}) => {
				results.value = data
				showSuccess(trans('general.shown'))
			}).catch(showValidationErrors).finally(() => {
				searching.value = false
			})
		} else {
			showWarning(trans('general.at_least_x_chars', {
				count: "3",
			}))
		}
	}
}

function select(country: Country):void{
	emit('selected', country)
	term.value = ''
	results.value = []
}

function clear():void{
	if(term.value.trim().length === 0){
		results.value = []
	}
}
</script>